import React from 'react';
import { Box, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { QlfFormRow } from '@qualifio/ui-commons';
import { TEXT_FIELD_SIZE } from '@loyalty/shared-common';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  root: {
    color: '#666666',
  },
  row: {
    marginBottom: '20px',
  },
  link: {
    color: '#61c1db',
  },
}));

export function GoogleFontForm() {
  const { control } = useFormContext();
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box textAlign="center">
      <Box className={classes.row}>
        {t('editor.custom-fonts.goole-fonts-ref1')}
        <a
          href="https://fonts.google.com/"
          className={classes.link}
          target="_blank"
          rel="noreferrer"
        >
          {'Google Fonts '}
        </a>
        {t('editor.custom-fonts.goole-fonts-ref2')}
      </Box>

      <Box alignItems="center">
        <QlfFormRow label={t('editor.custom-fonts.fields.name')} labelWidth={'25%'} mandatory>
          <Controller
            control={control}
            name="name"
            defaultValue=""
            render={({ field: { ref, ...field } }) => (
              <TextField
                fullWidth
                inputProps={{ maxLength: TEXT_FIELD_SIZE }}
                inputRef={ref}
                {...field}
                placeholder="Roboto"
              />
            )}
          />
        </QlfFormRow>

        <QlfFormRow label={t('editor.custom-fonts.fields.link')} labelWidth={'25%'} mandatory>
          <Controller
            control={control}
            name="settings.link"
            defaultValue=""
            render={({ field: { ref, ...field } }) => (
              <TextField
                fullWidth
                inputRef={ref}
                {...field}
                placeholder='<link href="https://fonts.googleapis.com/css2...'
              />
            )}
          />
        </QlfFormRow>

        <QlfFormRow label={t('editor.custom-fonts.fields.css-rule')} labelWidth={'25%'} mandatory>
          <Controller
            control={control}
            name="settings.cssRule"
            defaultValue=""
            render={({ field: { ref, ...field } }) => (
              <TextField
                fullWidth
                inputRef={ref}
                {...field}
                placeholder="font-family: 'Roboto', sans-serif;"
              />
            )}
          />
        </QlfFormRow>
      </Box>
    </Box>
  );
}

export function CustomFontForm() {
  const { control } = useFormContext();
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box textAlign="center">
      <Box className={classes.row}>{t('editor.custom-fonts.browser-compatibility')}</Box>
      <Box alignItems="center">
        <QlfFormRow label={t('editor.custom-fonts.fields.name')} labelWidth={'25%'} mandatory>
          <Controller
            control={control}
            name="name"
            defaultValue=""
            render={({ field: { ref, ...field } }) => (
              <TextField
                fullWidth
                inputProps={{ maxLength: TEXT_FIELD_SIZE }}
                inputRef={ref}
                {...field}
                placeholder="Roboto"
              />
            )}
          />
        </QlfFormRow>

        <QlfFormRow label={'TTF'} labelWidth={'25%'}>
          <Controller
            control={control}
            name="settings.ttf"
            defaultValue=""
            render={({ field: { ref, ...field } }) => (
              <TextField
                fullWidth
                inputRef={ref}
                {...field}
                placeholder="https://qualifio.com/fonts/myfont.ttf"
              />
            )}
          />
        </QlfFormRow>

        <QlfFormRow label={'OTF'} labelWidth={'25%'}>
          <Controller
            control={control}
            name="settings.otf"
            defaultValue=""
            render={({ field: { ref, ...field } }) => (
              <TextField
                fullWidth
                inputRef={ref}
                {...field}
                placeholder="https://qualifio.com/fonts/myfont.otf"
              />
            )}
          />
        </QlfFormRow>

        <QlfFormRow label={'WOFF'} labelWidth={'25%'}>
          <Controller
            control={control}
            name="settings.woff"
            defaultValue=""
            render={({ field: { ref, ...field } }) => (
              <TextField
                fullWidth
                inputRef={ref}
                {...field}
                placeholder="https://qualifio.com/fonts/myfont.woff"
              />
            )}
          />
        </QlfFormRow>
      </Box>
    </Box>
  );
}
